import { render, staticRenderFns } from "./DialogService.vue?vue&type=template&id=73a586ca&scoped=true"
import script from "./DialogService.vue?vue&type=script&lang=js"
export * from "./DialogService.vue?vue&type=script&lang=js"
import style0 from "./DialogService.vue?vue&type=style&index=0&id=73a586ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a586ca",
  null
  
)

export default component.exports